/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";

import { spacing } from "../../../../../../global/emotion";
import { cssMediaQueryMinWidthTablet } from "../../../../../lib/constants/emotionMediaQueries.constants";
import type { CommunityTotalsStatisticCardsProps as UseCommunityTotalsStatisticCardsProps } from "./useCommunityTotalsStatisticsCards.emotion";
import { useCommunityTotalsStatisticCards } from "./useCommunityTotalsStatisticsCards.emotion";

const tileMinWidth = "133px";

const containerStyle: Interpolation = {
  display: "none",
  [cssMediaQueryMinWidthTablet]: {
    display: "grid",
    gridAutoColumns: `minmax(${tileMinWidth}, 1fr)`,
    gridAutoFlow: "column",
    overflowX: "auto",
    /* Without this the `visible` block axis computes to `auto` alongside it. */
    overflowY: "hidden",
    scrollSnapType: "inline proximity",
    /* Hidden, to match the carousels elsewhere on the dashboard. */
    scrollbarWidth: "none",
    "::-webkit-scrollbar": {
      display: "none",
    },
    "> *": {
      scrollSnapAlign: "start",
    },
  },
  gap: spacing.m,
  paddingBottom: spacing.l,
  paddingTop: spacing.l,
};

export type CommunityTotalsStatisticCardsProps =
  UseCommunityTotalsStatisticCardsProps;

export const CommunityTotalsStatisticCards = ({
  id,
  metrics,
  range = "all",
  selectedType,
  onSelectMetric,
}: CommunityTotalsStatisticCardsProps) => {
  const { statisticCards } = useCommunityTotalsStatisticCards({
    id,
    metrics,
    range,
    selectedType,
    onSelectMetric,
  });

  return <div css={containerStyle}>{statisticCards}</div>;
};

CommunityTotalsStatisticCards.displayName = "CommunityTotalsStatisticCards";
